<app-header></app-header>
<!-- <app-header-public *ngIf="!loggedin"></app-header-public> -->

<main class="bx--content">
	<router-outlet></router-outlet>
</main>

<script src='https://api.mapbox.com/mapbox-gl-js/v1.0.0/mapbox-gl.js'></script>
<link href='https://api.mapbox.com/mapbox-gl-js/v1.0.0/mapbox-gl.css' rel='stylesheet' />
